import '../../css/product-page-configurations-old.scss';
import $ from '@modules/jquery-import';
import 'underscore';
import {Backbone, ProductConfiguratorApp} from '@modules/lazy-imports';

window.$ = window.$ || $;

Backbone()
    .then( ProductConfiguratorApp )
    .then( App => {
        const contentEl = document.getElementById( 'body-content' );
        if ( contentEl ) {
            contentEl.classList.remove( 'degraded' );
        }

        App.default.initialize();
    } );
